"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameWall = void 0;
var BaseWall_1 = require("./Wall/BaseWall");
var GameWall = /** @class */ (function () {
    function GameWall(width, height, x, y, hidden) {
        this._wall = new BaseWall_1.BaseWall(width, height, x, y, hidden);
        this._object = this._wall.body;
    }
    Object.defineProperty(GameWall.prototype, "object", {
        get: function () { return this._object; },
        enumerable: false,
        configurable: true
    });
    return GameWall;
}());
exports.GameWall = GameWall;
